export default __webpack_public_path__ + "img/landscape_0.ae38fbf398cb1ed3daf3b486d4133082.jpg";